import api from './api'
import { withAIConfig } from '../utils/aiRequest'

/** 卷级角色人设卡 */
export interface VolumeCharacterProfile {
  id: number
  novelId?: number
  volumeId: number
  characterName: string
  currentPersona?: string
  coreMotivation?: string
  stanceRelationships?: string
  unfinishedGoals?: string
  behaviorBottomLine?: string
  createdTime?: string
  updatedTime?: string
}

export interface GenerateVolumeCharacterProfilesResult {
  count: number
  profiles: VolumeCharacterProfile[]
}

function asArray(res: any): VolumeCharacterProfile[] {
  if (Array.isArray(res)) return res as VolumeCharacterProfile[]
  if (res && Array.isArray(res.data)) return res.data as VolumeCharacterProfile[]
  return []
}

function asProfile(res: any): VolumeCharacterProfile {
  if (res && res.data && typeof res.data === 'object') return res.data as VolumeCharacterProfile
  return res as VolumeCharacterProfile
}

/** 获取某卷的全部角色人设卡 */
export const getVolumeCharacterProfiles = async (
  volumeId: number,
): Promise<VolumeCharacterProfile[]> => {
  const res: any = await api.get(`/volumes/${Number(volumeId)}/character-profiles`)
  return asArray(res)
}

/** AI 生成某卷的角色人设卡 */
export const generateVolumeCharacterProfiles = async (
  volumeId: number,
  modelId?: string,
  requirement?: string,
): Promise<GenerateVolumeCharacterProfilesResult> => {
  const body = withAIConfig({ requirement: requirement || '' }, modelId ? { model: modelId } : undefined)
  const res: any = await api.post(`/volumes/${Number(volumeId)}/character-profiles/generate`, body)
  const profiles = asArray(res?.data?.profiles ? res.data.profiles : res?.profiles ?? res)
  const count = Number(res?.data?.count ?? res?.count ?? profiles.length)
  return { count, profiles }
}

/** 新建角色人设卡 */
export const createVolumeCharacterProfile = async (
  volumeId: number,
  payload: Partial<VolumeCharacterProfile>,
): Promise<VolumeCharacterProfile> => {
  const res: any = await api.post(`/volumes/${Number(volumeId)}/character-profiles`, payload)
  return asProfile(res)
}

/** 更新角色人设卡 */
export const updateVolumeCharacterProfile = async (
  id: number,
  payload: Partial<VolumeCharacterProfile>,
): Promise<VolumeCharacterProfile> => {
  const res: any = await api.put(`/volumes/character-profiles/${Number(id)}`, payload)
  return asProfile(res)
}

/** 删除角色人设卡 */
export const deleteVolumeCharacterProfile = async (id: number): Promise<void> => {
  await api.delete(`/volumes/character-profiles/${Number(id)}`)
}
